/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyFrontOffice\AutobuyClient\src\Utils\ThemeColor.ts
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyFrontOffice\AutobuyClient
 * Created Date: Thursday August 31st 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Thursday August 31st 2023 4:52:30 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import { MyColors } from "Config/Theme/Theme.type";

export function getThemeColor(value?: string, theme?: MyColors): string {
    var color = "";
    switch (value) {
        case "CITYCAR":
            color = "#BDD138";
            break;
        case "SUV":
            color = "#46abe1";
            break;
        case "UTILITY":
            color = "#ffda00";
            break;
        case "SEDAN":
            color = "#9492f7";
            break;
        case "BREAK":
            color = "#e35d9e";
            break;
        case undefined:
        case "":
        default:
            color = "#418fde";
            break;
    }
    return color;
}

export function lightenHexColor(hex: string, percent: number) {
    // Convertir la couleur hexadécimale en RGB
    let r = parseInt(hex.substring(1, 3), 16);
    let g = parseInt(hex.substring(3, 5), 16);
    let b = parseInt(hex.substring(5, 7), 16);

    // Augmenter chaque composante de 10%
    r = Math.min(255, Math.floor(r + (r * percent / 100)));
    g = Math.min(255, Math.floor(g + (g * percent / 100)));
    b = Math.min(255, Math.floor(b + (b * percent / 100)));

    // Convertir les composantes RGB en hexadécimal
    const newHex = `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;

    return newHex;
};

export function hexToRgba(hex: string, opacity: number) {
    // Valider la chaîne hexadécimale
    hex = String(hex).replace(/[^0-9a-f]/gi, '');
    if (hex.length === 3) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }

    // Convertir le hex en RGB
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // Limiter l'opacité entre 0 et 1
    opacity = Math.max(0, Math.min(1, opacity));

    // Retourner le résultat en format rgba
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
}
